import React from "react";
import { Link } from "react-router-dom";

const SideBar = (props) => {
  return (
    <div className="list-group sidebar mt-5">
      <Link to="/~atanu.metya/research/computationalDrugDesign" className={props.drug ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}
        aria-current="true">
      Computational Drug Design 
      </Link>
      <Link to="/~atanu.metya/research/nucleation" className={props.nucleation ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}>
      Nucleation
      </Link>
      <Link to="/~atanu.metya/research/interfacialPhenomenaAndNanoconfinement" className={props.interfacial ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}>
      Interfacial Phenomena and Nanoconfinement
      </Link>
      <Link to="/~atanu.metya/research/machineLearning" className={props.machineLearning ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}>
      DFT and Machine Learning
      </Link>
    </div>
  );
};

export default SideBar;
